<style lang="scss">
  .video-wrapper {
  }
  .plyr__poster {
    pointer-events: none;
  }
</style>

<template>
  <div class="container">
    <div class="grid lg:grid-cols-12">
      <div class="w-full video-wrapper justify-center lg:col-start-2 lg:col-span-10">
        <div class="plyr__video-embed" id="player" ref="player">
          <iframe id="playerframe" :src="url" allowfullscreen allowtransparency allow="autoplay"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Plyr from "plyr";

  export default {
    props: {
      videoId: {
        type: String,
        required: false,
      },
      videoUrl: {
        type: String,
        required: false,
      },
    },

    data() {
      return {
        player: null,
      };
    },

    mounted() {
      var self = this;
      this.player = new Plyr(this.$refs.player);
      this.player.play();
    },

    computed: {
      url() {
        if (this.videoUrl.includes("youtu")) {
          let videoId = "";
          if (this.videoUrl.includes("embed")) {
            videoId = this.videoUrl.split("embed/")[1].split("&")[0];
          } else if (this.videoUrl.includes("watch")) {
            videoId = this.videoUrl.split("v=")[1].split("&")[0];
          } else if (this.videoUrl.includes("shorts")) {
            videoId = this.videoUrl.split("shorts/")[1].split("?")[0];
          } else if (this.videoUrl.includes("youtu.be")) {
            videoId = this.videoUrl.split("youtu.be/")[1].split("?")[0];
          } else {
            console.error("unknown youtube url");
          }
          return `https://www.youtube.com/embed/${videoId}`
        }

        return this.videoUrl
          ? this.videoUrl
          : `https://player.vimeo.com/video/${this.videoId}?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media`;
      },
    },
  };
</script>
